module.exports = __webpack_public_path__ + "img/demandBg.8eb20aed.png";